import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const RentalsPage = lazy(() => import('../pages/rentals/page'));
const RentalsPageES = lazy(() => import('../pages/rentals-es/page'));
const RelocationPage = lazy(() => import('../pages/relocation/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const ThankYouGuidePage = lazy(() => import('../pages/thank-you-guide/page'));
const ThankYouMeetingPage = lazy(() => import('../pages/thank-you-meeting/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: React.createElement(HomePage),
  },
  {
    path: '/about',
    element: React.createElement(AboutPage),
  },
  {
    path: '/services',
    element: React.createElement(ServicesPage),
  },
  {
    path: '/rentals',
    element: React.createElement(RentalsPage),
  },
  {
    path: '/alquileres',
    element: React.createElement(RentalsPageES),
  },
  {
    path: '/relocation',
    element: React.createElement(RelocationPage),
  },
  {
    path: '/privacy-policy',
    element: React.createElement(PrivacyPolicyPage),
  },
  {
    path: '/thank-you-guide',
    element: React.createElement(ThankYouGuidePage),
  },
  {
    path: '/thank-you-meeting',
    element: React.createElement(ThankYouMeetingPage),
  },
  {
    path: '*',
    element: React.createElement(NotFoundPage),
  },
];

export default routes;